import _ from "lodash";
import React from "react";
import { useLazyGetReviewsSummaryQuery } from "../../../services/clientreviews";


export const ReviewsSummaryContext = React.createContext();

export const useReviewsSummaryData = () => React.useContext(ReviewsSummaryContext)

export const ReviewsSummaryProvider = ({ children, filter = null, isReady = false }) => {
    const [load, { data, error, isLoading, isFetching }] = useLazyGetReviewsSummaryQuery();
    const onHold = data?.onHold ?? 0;

    const reload = () => {
        if (!isReady || !filter || _.isEmpty(filter)) {
            return;
        }
        load({ ...filter }).unwrap();
    };

    React.useEffect(reload, [ filter, isReady ]);

    return (
        <ReviewsSummaryContext.Provider value={{ data, error, isLoading, isFetching, onHold }}>
            {children}
        </ReviewsSummaryContext.Provider>
    )
}